import { MenuButton } from "@chakra-ui/menu";
import styled from "styled-components";

export namespace styles {
  export const Wrapper = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
  `;
  export const StyledMenuButton = styled(MenuButton)`
    border-radius: 30px;
    width: 300px;
    height: 50px;
    border: solid 2px #e2e2e2;
    box-shadow: 0px 13px 16px #0000000a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 25px 0 25px;

    &:hover {
      cursor: pointer;
    }
  `;

  export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 15px;
    justify-content: space-between;
  `;
  export const HeaderHolder = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `;

  export const HeaderIcon = styled.div`
    display: flex;
    flex-direction: row;
    margin: 10px;
  `;

  export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
  `;

  export const Title = styled.div`
    color: black;
    font-size: 20px;
    font-weight: 600;
    margin-right: 5px;
    display: flex;
  `;
  export const SubTitle = styled.div`
    color: black;
    font-size: 16px;
    font-weight: normal;
    margin-right: 5px;
  `;

  export const Description = styled.div``;

  export const Content = styled.div`
    width: 100%;
    height: 100%;
    padding: 20px;
  `;

  export const Row = styled.div`
    display: flex;
    flex-direction: row;
    width: 950px;
    margin: 20px 0 20px 0;
    align-items: center;
    justify-content: space-between;
  `;
  export const RowTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
  `;

  export const RowTitle = styled.div`
    font-weight: 600;
    font-size: 18px;
  `;
  export const RowDescription = styled.div``;
  export const RowButton = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `;
  export const RowButtonText = styled.div`
    font-size: 14px;
  `;

  export const RowButtonIcon = styled.div`
    font-size: 14px;
  `;

  export const RowOkIcon = styled.div``;
}

export default styles;
